import { resetSessionExpiryFlag } from "@/utils/apiErrorHandler";
import { IDENTITY_CONFIG, METADATA_OIDC } from "../utils/authConst";
import { UserManager, WebStorageStateStore } from "oidc-client";

export default class AuthService {
  UserManager;

  constructor() {
    this.UserManager = new UserManager({
      ...IDENTITY_CONFIG,
      userStore: new WebStorageStateStore({ store: window.localStorage }),
      metadata: {
        ...METADATA_OIDC
      }
    });
    // Logger

    this.UserManager.events.addUserLoaded((user) => {
      if (window.location.href.includes("signin-oidc")) {
        this.navigateToScreen();
      }
    });
    // this.UserManager.events.addSilentRenewError((e) => {
    //     //console.log("silent renew error", e.message);
    // });

    // this.UserManager.events.addAccessTokenExpired(() => {
    //   console.log("token expired");
    //   this.UserManager.signinSilent().catch(() => {
    //     this.logout();
    //   });
    // });

    // this.UserManager.events.addSilentRenewError(() => {
    //   this.logout();
    // });
  }

  signinRedirectCallback = async (): Promise<any> => {
    const user = await this.UserManager.signinRedirectCallback();
    resetSessionExpiryFlag(); // REQUIRED
    return user;
  };

  getUser = async (): Promise<any> => {
    const user = await this.UserManager.getUser();
    if (!user) {
      return await this.UserManager.signinRedirectCallback();
    }
    return user;
  };

  parseJwt = (token: string): any => {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace("-", "+").replace("_", "/");
    return JSON.parse(window.atob(base64));
  };

  signinRedirect = (): void => {
    localStorage.setItem("redirectUri", window.location.pathname);
    this.UserManager.signinRedirect({}).catch((err) => {
      console.error("Signin redirect failed", err);
    });
  };

  navigateToScreen = (): void => {
    window.location.replace("/");
  };

  isAuthenticated = (): boolean => {
    const key = `oidc.user:${IDENTITY_CONFIG.authority}:${IDENTITY_CONFIG.client_id}`;
    const raw: string | null = localStorage.getItem(key);

    if (raw === null || raw.trim() === "") {
      return false;
    }

    try {
      const oidcStorage = JSON.parse(raw) as { access_token?: string };
      return typeof oidcStorage.access_token === "string" && oidcStorage.access_token.length > 0;
    } catch {
      return false;
    }
  };

  signinSilent = (): void => {
    this.UserManager.signinSilent()
      .then((user) => {
        console.log("signed in", user);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  signinSilentCallback = (): void => {
    this.UserManager.signinSilentCallback().catch((err) => {
      console.error("Silent sign-in callback failed", err);
    });
  };

  createSigninRequest = (): any => {
    return this.UserManager.createSigninRequest();
  };

  logout = (): void => {
    void this.UserManager.signoutRedirect({
      id_token_hint: localStorage.getItem("id_token")
    });

    this.UserManager.clearStaleState().catch((err) => {
      console.error("Clear stale state failed", err);
    });
  };

  localLogout = (): void => {
    localStorage.clear();
    window.location.replace("/login");
  };

  signoutRedirectCallback = (): void => {
    this.UserManager.signoutRedirectCallback()
      .then(() => {
        localStorage.clear();
        window.location.replace("/login"); // Redirect to /login instead of /
      })
      .catch((err) => {
        console.error("Signout redirect callback failed", err);
        localStorage.clear();
        window.location.replace("/login");
      });

    this.UserManager.clearStaleState().catch((err) => {
      console.error("Clear stale state failed", err);
    });
  };

  getToken = (): string | null => {
    const key = `oidc.user:${IDENTITY_CONFIG.authority}:${IDENTITY_CONFIG.client_id}`;
    const raw: string | null = localStorage.getItem(key);

    if (raw === null || raw.trim() === "") {
      return null;
    }

    try {
      const oidcStorage = JSON.parse(raw) as { access_token?: unknown };

      return typeof oidcStorage.access_token === "string" && oidcStorage.access_token.length > 0
        ? oidcStorage.access_token
        : null;
    } catch {
      return null;
    }
  };
}
